import React from "react";
import { Route } from "react-router-dom";
import LearnerDashboard from "../Pages/Dashboard/LearnerDashboard";
import Engage from "../Pages/ELearning/Courses/Engage";
import LearnerFeedback from "../Pages/ELearning/FeedbackForms/LearnerFeedback";
import LearnerLearningPathway from "../Pages/ELearning/LearningPathways/LearnerLearningPathway";
import LearnerLearningPathways from "../Pages/ELearning/LearningPathways/LearnerLearningPathways";
import PrivacyPolicy from "../Pages/GDPR/PrivacyPolicy";
import MyAccount from "../Shared/Account/MyAccount";
import TakeABreak from "../Pages/TakeABreak/TakeABreak";
import LearnerProgressDashboard from "../Pages/Reports/LearnerProgressDashboard";

const LearnerRoutes = () => {
  return (
    <>
      <Route exact path="/my-account" component={MyAccount} />
      <Route exact path="/" component={LearnerDashboard} />
      <Route
        exact
        path="/my-progress/:learnerId"
        component={LearnerProgressDashboard}
      />
      <Route exact path="/engage/:id" component={Engage} />

      <Route
        exact
        path="/learning-pathways"
        component={LearnerLearningPathways}
      />
      <Route
        exact
        path="/learning-pathway/:id"
        component={LearnerLearningPathway}
      />

      <Route exact path="/feedback/:id" component={LearnerFeedback} />

      <Route exact path="/gdpr/privacy" component={PrivacyPolicy} />

      <Route exact path="/take-a-break" component={TakeABreak} />
    </>
  );
};

export default LearnerRoutes;
